import { render, staticRenderFns } from "./MenuSG.vue?vue&type=template&id=5e64f715&scoped=true&"
import script from "./MenuSG.vue?vue&type=script&lang=js&"
export * from "./MenuSG.vue?vue&type=script&lang=js&"
import style0 from "./MenuSG.vue?vue&type=style&index=0&id=5e64f715&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e64f715",
  null
  
)

export default component.exports